import { render, staticRenderFns } from "./DataField.vue?vue&type=template&id=32f8283e&scoped=true&"
import script from "./DataField.vue?vue&type=script&lang=js&"
export * from "./DataField.vue?vue&type=script&lang=js&"
import style0 from "./DataField.vue?vue&type=style&index=0&id=32f8283e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f8283e",
  null
  
)

export default component.exports